/* ZYMA cart — <zyma-basket-bar>: on phones and tablets, a checkout bar appears while the summary's
   checkout button is out of view. The cart component replaces its children after every change, so the
   element re-binds through its own lifecycle.

   Also opens the bag drawer from the header button. The button and the drawer are separate elements
   (the drawer must stay outside <header>), so the click is forwarded here. */
(() => {
  'use strict';

  if (!window.zymaBagOpenBound) {
    window.zymaBagOpenBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-zyma-bag-open]');
      if (!trigger) return;
      const drawer = document.getElementById(trigger.dataset.zymaBagOpen) || document.querySelector('cart-drawer-component');
      if (!drawer) return;
      event.preventDefault();
      customElements.whenDefined('cart-drawer-component').then(() => {
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.querySelector('dialog')?.showModal();
      });
    });
  }

  if (customElements.get('zyma-basket-bar')) return;

  class ZymaBasketBar extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('cart-items-component') || document;
      const target = scope.querySelector('.zyma-basket-summary__checkout');
      if (!target || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(([entry]) => this.setVisible(!entry.isIntersecting));
      this.observer.observe(target);
    }

    setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      this.querySelectorAll('button').forEach((button) => { button.tabIndex = visible ? 0 : -1; });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('zyma-basket-bar', ZymaBasketBar);
})();
